import type {
  SchemaCondition,
  SchemaField,
  SchemaFieldNumber,
  SchemaFieldSelect,
  SchemaFieldSeveritySection,
  SchemaFieldText,
  SchemaOperator,
  SchemaOperatorEmpty,
} from "./schema.type";

import { isValidObject } from "@/utilities/object";

import { SCHEMA_EMPTY_OPERATORS, SCHEMA_OPERATORS } from "./schema.constant";

export const isSchemaFieldText = (
  schema: SchemaField
): schema is SchemaFieldText => {
  return schema.type === "input" && schema.inputType === "text";
};

export const isSchemaFieldNumber = (
  schema: SchemaField
): schema is SchemaFieldNumber => {
  return schema.type === "input" && schema.inputType === "number";
};

export const isSchemaFieldSelect = (
  schema: SchemaField
): schema is SchemaFieldSelect => {
  return schema.type === "select" && !isSchemaFieldSeveritySection(schema);
};

export const isSchemaFieldSeveritySection = (
  schema: SchemaField
): schema is SchemaFieldSeveritySection => {
  return "isFrozen" in schema && schema.isFrozen === true;
};

export const isSchemaOperator = (
  operator: string
): operator is SchemaOperator =>
  SCHEMA_OPERATORS.includes(operator as SchemaOperator);

export const isSchemaOperatorEmpty = (
  operator: string
): operator is SchemaOperatorEmpty =>
  SCHEMA_EMPTY_OPERATORS.includes(operator as SchemaOperatorEmpty);

export const isSchemaConditionValue = (
  value?: unknown
): value is SchemaCondition => {
  if (!value) return false;
  if (!isValidObject(value)) return false;
  if (!("model" in value && value.model)) return false;
  if (!("condition" in value && value.condition)) return false;
  if (!(typeof value.condition === "string")) return false;
  return isSchemaOperator(value.condition);
};
